// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610151735/js/" + chunkId + "." + {"44":"7227202b","225":"7d863a13","481":"22ec3504","486":"b1e2e01f","770":"34ac8b38"}[chunkId] + ".0.6686691383934805.chunk.js";
};